import React from 'react';
import { useTranslation } from 'react-i18next';
import { useDirection } from '@/providers/DirectionProvider';
import { Button } from '@/components/ui/button';
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle
} from '@/components/ui/dialog';
import { User, Phone } from 'lucide-react';

interface ProfileIncompleteDialogProps {
  isOpen: boolean;
  onOpenChange: (open: boolean) => void;
  onGoToProfile: () => void;
}

const ProfileIncompleteDialog: React.FC<ProfileIncompleteDialogProps> = ({
  isOpen,
  onOpenChange,
  onGoToProfile
}) => {
  const { t } = useTranslation();
  const { direction } = useDirection();

  return (
    <Dialog open={isOpen} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-md" dir={direction}>
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2">
            <User className="h-5 w-5" />
            {t('dialogs.profileIncomplete.title')}
          </DialogTitle>
          <DialogDescription>
            {t('dialogs.profileIncomplete.description')}
          </DialogDescription>
        </DialogHeader>
        <div className="flex flex-col gap-4 py-4">
          <div className="bg-blue-50 p-4 rounded-lg">
            <h4 className="font-medium text-blue-900 mb-2">{t('dialogs.profileIncomplete.requiredInfoTitle')}</h4>
            <div className="space-y-2 text-sm text-blue-800">
              <div className="flex items-center gap-2">
                <User className="h-4 w-4" />
                <span>{t('dialogs.profileIncomplete.fullName')}</span>
              </div>
              <div className="flex items-center gap-2">
                <Phone className="h-4 w-4" />
                <span>{t('dialogs.profileIncomplete.phoneNumber')}</span>
              </div>
            </div>
          </div>
          <p className="text-sm text-muted-foreground">
            {t('dialogs.profileIncomplete.message')}
          </p>
        </div>
        <DialogFooter className="flex-col sm:flex-row gap-2">
          <Button
            variant="outline"
            onClick={() => onOpenChange(false)}
            className="w-full sm:w-auto"
          >
            {t('common.cancel')}
          </Button>
          <Button
            onClick={onGoToProfile}
            className="w-full sm:w-auto bg-[#00D09E] hover:bg-[#00C090]"
          >
            {t('dialogs.profileIncomplete.completeProfileButton')}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};

export default ProfileIncompleteDialog;